import { ReactElement } from 'react';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';

import Rule from './Rule';

import styles from './NotificationRules.module.scss';
import { INotificationRule } from '~/services/api/notificationRules/types';
import NoDataFound from '../../../NoDataFound';

interface IProps {
  showBorder?: boolean;
  rules: INotificationRule[];
  canManage?: boolean;
  showDescriptionHint?: boolean;
  onRemove: (index: number) => void;
}

const NotificationRules = ({
  showBorder = true,
  rules,
  canManage = true,
  showDescriptionHint = false,
  onRemove,
}: IProps): ReactElement => (
  <div className={showBorder ? styles.notificationRules : ''}>
    <div className={styles.title}>
      {showDescriptionHint && (
        <div>
          <span>Notification Rules</span>
          <span className={styles.hint}>
            (Patient notification rules supersede the program notification rules)
          </span>
        </div>
      )}
    </div>
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Reading Type</TableCell>
            <TableCell>Condition</TableCell>
            <TableCell>Level 1</TableCell>
            <TableCell>Level 2</TableCell>
            <TableCell>Level 3</TableCell>
            {canManage && (
              <TableCell align="center" width={80}>
                Remove
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          <>
            {rules.length !== 0 ? (
              <>
                {rules.map(item => (
                  <Rule key={item.id} rule={item} canManage={canManage} onRemove={onRemove} />
                ))}
              </>
            ) : (
              <TableRow>
                <TableCell colSpan={canManage ? 6 : 5}>
                  <NoDataFound />
                </TableCell>
              </TableRow>
            )}
          </>
        </TableBody>
      </Table>
    </TableContainer>
  </div>
);

export default NotificationRules;
